import React from 'react';

import { Button, Theme } from '@havenengineering/module-shared-library/dist/components/Button';
import styles from './select-button.module.scss';

export type SelectButtonProps = {
  label?: string;
  active?: boolean | null;
  url?: string;
  onClick?: () => void;
};

export const SelectButton = ({
  label = 'Select',
  active,
  url = '',
  onClick,
}: SelectButtonProps) => (
  <div className={styles.selectButtonContainer}>
    {active ? (
      <Button
        className={styles.button}
        theme={Theme.PRIMARY_THEME}
        disabled={active || undefined}
        data-testid="select-button"
        block
        href={active ? url : undefined}
        onClick={onClick}
      >
        {label}
      </Button>
    ) : (
      <Button
        className={styles.button}
        theme={Theme.PRIMARY_THEME}
        disabled
        data-testid="select-button"
        block
      >
        {label}
      </Button>
    )}
  </div>
);
